module.exports = __webpack_public_path__ + "img/internet-images.2e2ca7ab.svg";